import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-explorer-item-edit-view',
  templateUrl: './explorer-item-edit-view.component.html',
  styleUrls: ['./explorer-item-edit-view.component.css']
})
export class ExplorerItemEditViewComponent implements OnInit {
  id!: string | null;

  constructor(private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id");
    document.getElementsByClassName("head")[0].scrollIntoView();
  }

}
